import { atom } from 'jotai';
import { minMaxFilterAtom } from '@/utils/atoms/filter';
import { filterValueAtom } from './filter';

export const xgMinMaxFilterAtom = minMaxFilterAtom(
  'event.attributes.xg',
  filterValueAtom('minXg'),
  filterValueAtom('maxXg'),
);

const adjustedMaxMatchMinuteAtom = atom(get => {
  const max = get(filterValueAtom('maxMatchMinute'));
  return typeof max === 'number' ? max - 1 : undefined;
});

export const minuteMinMaxFilterAtom = minMaxFilterAtom(
  'event.attributes.minute',
  filterValueAtom('minMatchMinute'),
  adjustedMaxMatchMinuteAtom,
);
